// Single source of truth for everything brand specific.
// Renaming the site = editing this file (plus the theme key mirrored in public/index.html).

const DOMAIN = 'igenfunxyz.com';

export const SITE = {
    name: 'igenfunXYZ',
    nameParts: ['igenfun', 'XYZ'],
    tagline: 'AI photo & video generator',
    year: 2026,
    domain: DOMAIN,
    emails: {
        support: `support@${DOMAIN}`,
        abuse: `abuse@${DOMAIN}`,
        press: `press@${DOMAIN}`,
        legal: `legal@${DOMAIN}`,
        complaints: 'complains@hotmate.ai',
    },
    company: {
        name: 'Hotmate Ltd',
        address: 'Giannou Kranidioti & Pargas, 9, office 102, Nicosia, 1065, Cyprus',
    },
    docs: {
        termsPdf: 'https://cdn.hotmate.ai/docs/Hotmate - Terms of Services - 01-09-2025.pdf',
        notice2257Pdf: 'https://cdn.hotmate.ai/docs/Hotmate - 18 U.S.C. 2257 Exemption - 01-04-2025.pdf',
    },
    checkoutProvider: 'Centrobill',
    downloadPrefix: 'igenfunxyz',
    storage: {
        theme: 'igx_theme',
        age: 'igx_age_confirmed',
        offer: 'igx_offer_started',
    },
};
